<template>
    <div>
        <div class="indexcon">
            <banner :banner="bannerList"></banner>
        </div>
        <div class="mains">
            <div class="mainCon">
                <div class="relist flx">
                    <div class="reItem" @click="toDetail1(item)" v-for="item,index in recommand">
                        <div class="labelName" v-text="item.label" v-if="item.label">
            
                        </div>
                        <div class="reImg">
                            <img :src="$img(item.avatar)" alt="" />
                        </div>
                        <div class="reInfo">
                            <div class="reName multy2" v-text="item.name"></div>
                            <div class="reTitle single" v-text="item.title"></div>
                            <div class="flx" style="justify-content: flex-end;margin-top: 20px;">
                                <div class="rebtn" v-if="item.category_id == 2 && item.is_type == 3">
                                    马上预约
                                </div>
                                <div class="rebtn" v-if="item.category_id == 2 && item.is_type == 2">
                                    观看回放
                                </div>
                                <div class="rebtn" v-if="item.category_id == 2 && item.is_type == 1">
                                    了解课程
                                </div>
                                <div class="rebtn" v-if="item.category_id != 2">
                                    马上报名
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        recommands
    } from "@/api/index.js"
        import banner from "@/components/banner.vue"
    export default {
        name: "index",
        components: {
            banner
        },
        data() {
            return {
                page:1,
                recommand:[],
                bannerList:[]
            };
        },
        created() {
            this.getList()
        },
        methods: {
           getList(){
               let that = this
               let data = {}
               data.size = 40
               data.page = that.page
               recommands(data).then((res) => {
                   if(res.code == 1){
                       that.recommand = res.data.list.data
                       that.bannerList = res.data.banner
                       that.$nextTick(() => {
                           window.scrollTo(0, 0)
                       })
                   }
               })
           },
            toDetail1(e) {
                let that = this
                if (e.category_id == 1) {
                    this.$router.push({
                        path: '/signDetail', // 写路由path
                        query: {
                            id: e.goods_id
                        }
                    })
                } else if (e.category_id == 2) {
                    this.$router.push({
                        path: '/liveDetail', // 写路由path
                        query: {
                            id: e.goods_id
                        }
                    })
                } else if (e.category_id == 3) {
                    this.$router.push({
                        path: '/RecruitmentDetail', // 写路由path
                        query: {
                            id: e.goods_id
                        }
                    })
                } else if (e.category_id == 4) {
                    this.$router.push({
                        path: '/coachDetail', // 写路由path
                        query: {
                            id: e.goods_id
                        }
                    })
                } else if (e.category_id == 5) {
                    this.$router.push({
                        path: '/cerDetail', // 写路由path
                        query: {
                            id: e.goods_id
                        }
                    })
                } else if (e.category_id == 6) {
                    this.$router.push({
                        path: '/eduDetail', // 写路由path
                        query: {
                            id: e.goods_id
                        }
                    })
                } else if (e.category_id == 7) {
                    this.$router.push({
                        path: '/bookDetail', // 写路由path
                        query: {
                            id: e.goods_id
                        }
                    })
                } else if (e.category_id == 8) {
                    this.$router.push({
                        path: '/serviceDetail', // 写路由path
                        query: {
                            id: e.goods_id
                        }
                    })
                }
            },
           
            
           
        }
    };
</script>

<style scoped>
    .labelName {
        height: 29px;
        background: linear-gradient(79deg, #F59E0B 0%, #F4870A 100%);
        border-radius: 15px 15px 15px 2px;
        box-sizing: border-box;
        padding: 0 11px;
        line-height: 29px;
        position: absolute;
        left: 12px;
        top: 12px;
        font-weight: 600;
        font-size: 13px;
        color: #FFFFFF;
    }
    
    .cateItem {
        width: 350px;
        height: 262px;
        border-radius: 8px;
        margin-bottom: 21px;
    }
    
    .cateList {
        flex-wrap: wrap;
    }
    
    .cateItem img {
        width: 100%;
        height: 100%;
    
    }
    
    .coaname {
        font-weight: 500;
        font-size: 18px;
        color: #222222;
        margin-bottom: 8px;
    }
    
    .coatitle {
        font-size: 14px;
        color: #999999;
    }
    
    .coaingo {
        box-sizing: border-box;
        padding: 20px;
        text-align: left;
    }
    
    .coaitem {
        width: 275px;
        height: 361px;
        background: #FFFFFF;
        border-radius: 12px;
        overflow: hidden;
        margin-right: 10px;
        overflow: hidden;
    }
    
    .coaImage {
        width: 275px;
        height: 268px;
    }
    
    .coaImage img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    
    .bookprice {
        margin-bottom: 6px;
    }
    
    .oprice {
        font-size: 12px;
        color: #9CA3AF;
        font-size: 12px;
        color: #9CA3AF;
        text-decoration-line: line-through;
    }
    
    .bprice {
        font-weight: 600;
        font-size: 18px;
        color: #FF6A00;
    }
    
    .sales {
        font-size: 12px;
        color: #9CA3AF;
    }
    
    .bookName {
        width: 100%;
        font-weight: 600;
        font-size: 14px;
        margin-bottom: 6px;
    
    }
    
    .bookau {
        font-weight: 500;
        font-size: 12px;
        color: #6B7280;
        margin-bottom: 19px;
    }
    
    .bookInfo {
        width: 244px;
        text-align: left;
    }
    
    .bookItem {
        box-sizing: border-box;
        padding: 16px 0;
        border-bottom: 1px solid #EDEDED;
    }
    
    .booksContent {
        box-sizing: border-box;
        padding: 0 20px;
        background: #fff;
    }
    
    .bookImage {
        width: 101px;
        height: 130px;
        border-radius: 12px;
        margin-right: 16px;
    }
    
    .bookImage img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    
    .hrlabel {
        font-weight: 500;
        font-size: 12px;
        color: #374151;
        box-sizing: border-box;
        padding: 6px 16px;
        background: #F3F4F6;
        border-radius: 15px;
        margin-right: 14px;
    }
    
    .hrtop {
        margin-bottom: 18px;
    }
    
    .hrtitle div {
        margin-right: 20px;
    }
    
    .hrtitle {
        font-size: 14px;
        color: #4B5563;
        margin-bottom: 18px;
    }
    
    .hrname {
        font-weight: 600;
        font-size: 28px;
        color: #000000;
        margin-right: 20px;
    }
    
    .hrPrice {
        font-weight: 600;
        font-size: 28px;
        color: #FF6A00;
    }
    
    .hritem {
        width: 100%;
        height: 184px;
        background: #FFFFFF;
        border-radius: 12px;
        box-sizing: border-box;
        padding: 30px 27px;
        margin-bottom: 30px;
    }
    
    .wbLeft .titles {
        margin-bottom: 27px;
    }
    
    .wbLeft {
        width: 1027px;
    
    }
    
    .wbRight {
        width: 400px;
    }
    
    .wbContent {
        width: 1460px;
        margin: 0 auto;
        box-sizing: border-box;
        padding-top: 56px;
    }
    
    .wbkcon {
        width: 100%;
        background: #F9FAFB !important;
        box-sizing: border-box;
        padding-bottom: 56px;
    }
    
    .reImg {
        width: 344px;
        height: 194px;
        overflow-y: hidden;
    }
    
    .reImg img {
        width: 100%;
    }
    
    .rebtn {
        width: 104px;
        height: 36px;
        background: linear-gradient(90deg, #4A9EFF 0%, #1E7FE5 100%);
        box-shadow: 0px 2px 6px 0px rgba(30, 127, 229, 0.25);
        border-radius: 18px;
        font-size: 14px;
        color: #FFFFFF;
        text-align: center;
        line-height: 36px;
    }
    
    .reTitle {
        font-weight: 500;
        font-size: 14px;
        color: #9CA3AF;
        margin-top: 10px;
    }
    
    .reInfo {
        box-sizing: border-box;
        padding: 20px;
        text-align: left;
    }
    
    .reName {
        height: 48px;
        line-height: 24px;
        width: 100%;
        font-weight: 600;
        font-size: 16px;
        color: #000000;
    }
    
    .relist {
        flex-wrap: wrap;
        justify-content: flex-start;
        box-sizing: border-box;
        padding-bottom: 56px;
        gap: 20px;
    }
    
    .reItem {
        width: 344px;
        height: 372px;
        background: #FFFFFF;
        box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        margin-bottom: 28px;
        overflow: hidden;
        position: relative;
    }
    
    .titles {
        margin-bottom: 27px;
    }
    
    .checkmopre {
        width: 64px;
        /* height: 17px; */
    }
    
    .titleft {
        font-weight: 600;
        font-size: 30px;
        color: #000;
    }
    
    .mainCon {
        width: 1460px;
        margin: 0 auto;
        box-sizing: border-box;
        padding-top: 56px;
    }
    
    .mains {
        width: 100%;
        background: #fff;
    }
    
    .lookMore {
        font-weight: 600;
        font-size: 18px;
        color: #666666;
    }
    
    .innerTxt {
        font-size: 18px;
        font-weight: bold;
    }
    
    .innernotice {
        width: 1460px;
    }
    
    .notice {
        width: 100%;
        height: 80px;
        background: #F3F4F6;
    }
</style>